const isomorphicMatchMedia = (media) => {
  const supportsMatchMediaApi =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function';

  if (!supportsMatchMediaApi) {
    /**
     * Mock object, used to simplify logic inside the React component
     * by providing dummy properties and methods.
     *
     * Never matches any media, making it useful for SSR.
     */
    return {
      media,
      matches: false,
      addListener: () => undefined,
      removeListener: () => undefined,
    };
  }

  return window.matchMedia(media);
};

export default isomorphicMatchMedia;
